var map = {
	"./10k-drive.svg": 38329,
	"./18-plus.svg": 91644,
	"./18plus.svg": 10595,
	"./18plusMrGreen.svg": 94935,
	"./24h.svg": 33086,
	"./888club.svg": 36436,
	"./888club2.svg": 62030,
	"./888wetten.svg": 29257,
	"./AvatarIcon.svg": 13628,
	"./Icon-18.svg": 38631,
	"./Sjalvtest.svg": 11514,
	"./SjalvtestMrGreen.svg": 73248,
	"./Spelgranser.svg": 15850,
	"./SpelgranserMrGreen.svg": 464,
	"./Spelpaus.svg": 52875,
	"./SpelpausMrGreen.svg": 62159,
	"./about-us.svg": 7444,
	"./account-statement.svg": 1525,
	"./account.svg": 17653,
	"./add-user.svg": 75535,
	"./alert.svg": 56402,
	"./app-download.svg": 25894,
	"./az-sports.svg": 49087,
	"./back-btn.svg": 84890,
	"./be-gamble-aware.svg": 68169,
	"./bell.svg": 37995,
	"./bet-feed-old.svg": 36966,
	"./bet-feed.svg": 8650,
	"./betfeed-mrg.svg": 82106,
	"./biometrics-login.svg": 26245,
	"./blog.svg": 58756,
	"./bonuses.svg": 46485,
	"./burger-old.svg": 57295,
	"./burger.svg": 51479,
	"./casino-daily-wish.svg": 13123,
	"./casino-game.svg": 69564,
	"./casino-history.svg": 94042,
	"./casino-mrg.svg": 99558,
	"./casino-si.svg": 87870,
	"./challanges-shield.svg": 73424,
	"./challenges.svg": 46866,
	"./chat.svg": 35514,
	"./check.svg": 50240,
	"./clock.svg": 79274,
	"./close-x.svg": 65483,
	"./close.svg": 71084,
	"./confirmed.svg": 87187,
	"./control-center.svg": 63891,
	"./cool_arrow.svg": 99421,
	"./cross-casino-logo.svg": 8492,
	"./cross-poker-logo.svg": 12220,
	"./cross-sell-casino-mobile.svg": 47802,
	"./cross-sell-casino.svg": 44827,
	"./cross-sell-poker-mobile.svg": 51616,
	"./cross-sell-poker.svg": 61253,
	"./cross-sell-sport-mobile.svg": 66783,
	"./cross-sell-sport.svg": 19052,
	"./cross-sport-logo.svg": 14971,
	"./de-migration-logo.svg": 22918,
	"./default-icon.svg": 73587,
	"./default-logo.svg": 58845,
	"./deposit.svg": 85098,
	"./depositLimit.svg": 75575,
	"./dice.svg": 81129,
	"./disconnect-error.svg": 1971,
	"./disconnect.svg": 52270,
	"./disconnected.svg": 95137,
	"./document-checked.svg": 76775,
	"./document.svg": 9387,
	"./documentWithTimer.svg": 49374,
	"./download-app.svg": 710,
	"./download.svg": 73416,
	"./e-magazine.svg": 29600,
	"./email.svg": 9120,
	"./face-id.svg": 22315,
	"./financial.svg": 45117,
	"./finger-print.svg": 42849,
	"./flag.svg": 92982,
	"./football.svg": 25563,
	"./free-bets.svg": 73331,
	"./free-play.svg": 821,
	"./freespin.svg": 70082,
	"./gam-care.svg": 67609,
	"./game-frame-close.svg": 9485,
	"./game-frame-eighteenplus.svg": 42396,
	"./game-frame-expand.svg": 19247,
	"./game-frame-shrink.svg": 24900,
	"./games.svg": 79993,
	"./gaming.svg": 8327,
	"./gear.svg": 51049,
	"./globe.svg": 81503,
	"./green-gaming.svg": 30201,
	"./help-link.svg": 52934,
	"./help.svg": 78601,
	"./history-new.svg": 60549,
	"./history.svg": 28736,
	"./home-new.svg": 84480,
	"./home.svg": 3213,
	"./hourglass.svg": 11958,
	"./how-to-deposit.svg": 53369,
	"./how-to-play.svg": 93735,
	"./icon-profile.svg": 42483,
	"./info-tip.svg": 19956,
	"./info.svg": 51652,
	"./inplay.svg": 93279,
	"./invite-a-friend.svg": 99982,
	"./leaderboard-new.svg": 45880,
	"./light.svg": 98764,
	"./live-now-side-menu.svg": 53045,
	"./live-old.svg": 26914,
	"./live.svg": 19286,
	"./localization-language.svg": 60242,
	"./localization-pin.svg": 33289,
	"./location-pin.svg": 99943,
	"./location-plugin.svg": 10491,
	"./location-plugin_si.svg": 85602,
	"./location-search-pin.svg": 41792,
	"./locker.svg": 74212,
	"./logo-18-plus.svg": 90430,
	"./logo-DGA-spillemyndigheden.svg": 18338,
	"./logo-SI-desktop-red-white.svg": 87899,
	"./logo-SI-mobile-header-white.svg": 63273,
	"./logo-abon.svg": 25760,
	"./logo-egt.svg": 26134,
	"./logo-mrg-mobile.svg": 73925,
	"./logo-mrg.svg": 21894,
	"./logo-oktocash.svg": 67010,
	"./logo-rofus.svg": 66203,
	"./logo-spil-ansvarligt.svg": 32186,
	"./logo-stop-spillet.svg": 69360,
	"./logout.svg": 31834,
	"./map-circle.svg": 22295,
	"./map-circle_si.svg": 95182,
	"./menu-spinner.svg": 58413,
	"./migrationro-hours.svg": 21295,
	"./migrationro-oneapp.svg": 86783,
	"./migrationro-tournaments.svg": 88002,
	"./mobile-light.svg": 91237,
	"./moneyWallet.svg": 21443,
	"./more.svg": 66691,
	"./mrgreen-myaccount-area.svg": 75252,
	"./notification.svg": 29301,
	"./odds.svg": 96958,
	"./offers.svg": 30901,
	"./perfect-10.svg": 11523,
	"./plus-cashier-mr-green.svg": 89234,
	"./plus-cashier.svg": 59388,
	"./poker-history.svg": 89720,
	"./poker-mrg.svg": 3880,
	"./poker.svg": 48039,
	"./pokerCards.svg": 7868,
	"./pokerDownloadUser.svg": 39658,
	"./poker_logo.svg": 60835,
	"./poker_logo_mobile.svg": 50292,
	"./popular.svg": 74175,
	"./popupLight.svg": 34634,
	"./promotions-prelogin.svg": 67029,
	"./promotions.svg": 41218,
	"./question-mark.svg": 16090,
	"./real-money-poker.svg": 28291,
	"./recommendations-old.svg": 38440,
	"./recommendations.svg": 50768,
	"./rectangle-poker.svg": 96895,
	"./redeem-gold-token.svg": 62499,
	"./redirect-focus.svg": 63907,
	"./register.svg": 56107,
	"./responsible-gaming.svg": 72426,
	"./result_arrow.svg": 59637,
	"./reverse-withdraw.svg": 45225,
	"./rewards.svg": 84244,
	"./search.svg": 13060,
	"./security.svg": 94090,
	"./session.svg": 84868,
	"./shield.svg": 50811,
	"./special-offers.svg": 32023,
	"./sport-history.svg": 8645,
	"./sport-mrg.svg": 9633,
	"./sport.svg": 48142,
	"./sport_cross_sell.svg": 70114,
	"./sport_logo.svg": 62056,
	"./sport_logo_VIP.svg": 63296,
	"./sport_logo_mobile.svg": 6805,
	"./sportwetten.svg": 94247,
	"./sportwetten_VIP.svg": 90939,
	"./sportwetten_mobile.svg": 7624,
	"./star-empty.svg": 97484,
	"./star.svg": 52344,
	"./starting_soon.svg": 2018,
	"./theme-mode.svg": 27505,
	"./ticket.svg": 46444,
	"./tickets-new.svg": 51482,
	"./title_races.svg": 28709,
	"./touch-id.svg": 56441,
	"./tournament-tickets.svg": 22941,
	"./tournaments.svg": 91208,
	"./tribal-white.svg": 25324,
	"./up-for-8.svg": 36654,
	"./upload-documents.svg": 69094,
	"./user-default-icon.svg": 51793,
	"./user-details.svg": 53824,
	"./user-icon-pre-login-default.svg": 15845,
	"./user.svg": 62777,
	"./vi-cross-sell-casino-mobile.svg": 59878,
	"./vi-cross-sell-poker-mobile.svg": 81316,
	"./vi-logo.svg": 98785,
	"./virtual-sports.svg": 82463,
	"./wallet.svg": 5799,
	"./winloss-history.svg": 66492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23299;